import _ from 'lodash';
import MomentDiffZone from '@/hooks/useMomentDiffZone';
import moment from 'moment';
/**
 * 获取可选择时间的数组
 * @param {*} startHour 开始小时数
 * @param {*} endHour 结束小时数
 * @param {*} startMinute 开始分钟数
 * @param {*} endMinute 结束分钟数
 * @param {*} interval 时间间隔
 * @returns 
 */
export function getTimeArray(startHour = 8, startMinute = 30, endHour = 23, endMinute = 0, interval = 15) {
  let hourArr = [];
  let minuteArr = []
  const iNum = endHour - startHour + 1;
  const mNum = 60 / interval;

  _.times(mNum, (i) => {
    const m = i * interval;
    const minute = {
      label: m < 10 ? '0' + m : m,
      value: m,
    }
    minuteArr.push(minute)
  })

  // 生成小时的结构
  _.times(iNum, (i) => {
    const h = startHour + i;
    const hour = {
      label: h,
      value: h
    }
    if (i === 0) {
      const specialMinuteArr = minuteArr.filter(item => {
        return item.value >= startMinute;
      })
      hour.children = specialMinuteArr;
    } else if (i === iNum - 1) {
      const specialMinuteArr = minuteArr.filter(item => {
        return item.value <= endMinute;
      })
      hour.children = specialMinuteArr;
    } else {
      hour.children = minuteArr;
    }
    hourArr.push(hour)
  })
  return hourArr
}

// 根据id滚动到底部
export function scrollMessageListToEnd(id = 'messageList-dialogue-blocks') {
  setTimeout(() => {
    let messageListwrapper = document.getElementById(id);
    if (messageListwrapper) {
      messageListwrapper.scrollTop = messageListwrapper.scrollHeight;
    }
  }, 0)
}

// 根据URL地址获取角色
/**
 * 
 * client
 * therapist,
 * admin,
 * robot: client/robot/ 这种情况算作robot
 */
export function getRoleFromLocation() {
  const createHistory = require('history').createBrowserHistory;
  let history = createHistory();
  const pathname = history.location.pathname;
  let role = pathname.split('/')[1];
  if (pathname.indexOf('/robot') > -1) {
    role = 'robot';
  }
  return role;
}

// 判断时间距离现在是否超过24小时
export function isMoreThan24Hours(time) {
  return MomentDiffZone(time).valueOf() - MomentDiffZone().valueOf() > 1000 * 60 * 60 * 24;
}
// 判断时间距离现在是否超过指定时间
export function isMoreThanSpecificHours(time, hours) {
  return MomentDiffZone(time).valueOf() - MomentDiffZone().valueOf() > 1000 * 60 * 60 * hours;
}

// 判断时间距离现在是否超过3分钟
export function isMoreThan3Mins(time) {
  const currentTime = MomentDiffZone().valueOf();
  const timeValue = MomentDiffZone(time).valueOf();
  return currentTime - timeValue > 1000 * 60 * 3;
}

// 删除数组中的指定元素
export function removeChild(arr, val) {
  var index = arr.indexOf(val)
  if (index > -1) {
    arr.splice(index, 1)
  }
  return arr;
}

// 判断时间是不是在工作时间内
export function isWorkTime(startWorkTime, endWorkTime) {
  // 无参数默认24小时工作
  if(!startWorkTime) {
    return true
  }
  // 转换开始结束时间
  const startTime = moment(startWorkTime, 'HH:mm');
  const endTime = moment(endWorkTime, 'HH:mm');
  const currentTime = moment();
  return currentTime.isBetween(startTime, endTime);
}

// 根据字符串生成hash值
export function generateHash(content) {
  // 引入 crypto 模块（node）
  const crypto = require('crypto');
  // 生成哈希值
  const hashObject = crypto.createHash('sha256');
  hashObject.update(content);
  const hashValue = hashObject.digest('hex');
  return hashValue;
}

// 洗牌算法，打乱数组顺序
export const shuffleArray = (array) => {
  const shuffledArray = [...array]; // 创建一个数组副本，避免修改原数组

  for (let i = shuffledArray.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1)); // 生成随机索引
    [shuffledArray[i], shuffledArray[j]] = [shuffledArray[j], shuffledArray[i]]; // 交换元素位置
  }

  return shuffledArray;
};

// 文本相似度比较
export function calculateSimilarity(text, textToCompare) {
  const str1 = text.replace(/[\u3002\uff1b\uff0c\uff1a\u201c\u201d\u2018\u2019\uff08\uff09\u3001\uff1f\u300a\u300b]/g, "")
  const str2 = textToCompare.replace(/[\u3002\uff1b\uff0c\uff1a\u201c\u201d\u2018\u2019\uff08\uff09\u3001\uff1f\u300a\u300b]/g, "")
  const jsLevenshtein = require('js-levenshtein');
  const distance = jsLevenshtein(str1.toUpperCase(), str2.toUpperCase());
  const maxLength = Math.max(str1.length, str2.length);
  const similarityPercentage = ((1 - distance / maxLength) * 100).toFixed(2);
  return similarityPercentage;
}

// URL 参数拼接，直接遍历对象，若为value为空，则不会拼接
export function _getQuerystr(params) {
  if (!params) return '';
  if (typeof (params) === 'string') return params
  const queryStr = Object.keys(params)
    .reduce((ary, key) => {
      if (key && params[key]) {
        ary.push(encodeURIComponent(key) + '=' + encodeURIComponent(params[key]));
      }
      return ary;
    }, [])
    .join('&');
  return '?' + queryStr;
}